export const emailValidationRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export const phoneNumberValidationRegex = /^\+?[0-9]{9,13}$/;
export const optionalPhoneNumberValidationRegex = /^(?:\+?[0-9]{9,13})?$/;
export const allowedChars = /[^a-zA-Z.,' -]/;
